import React, { useState } from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import About from './components/About';
import Realizations from './components/Realizations';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import LegalMentions from './components/LegalMentions';

function App() {
  const [showLegal, setShowLegal] = useState(false);

  return (
    <div className="App">
      {showLegal ? (
        <LegalMentions onClose={() => setShowLegal(false)} />
      ) : (
        <>
          <Header />
          <Hero />
          <About />
          <Services />
          <Realizations />
          <Testimonials />
          <Contact />
          <Footer onShowLegal={() => setShowLegal(true)} />
        </>
      )}
    </div>
  );
}

export default App;
